import { createBankAccount, deleteBankAccount, editBankAccount, getBankAccounts } from '../../../backend-services/bank';
import React, { useEffect, useState } from 'react';
import {  BankData } from '../../../types';
import CreateBankAccount from './create';
import toast from 'react-hot-toast';
import { Button } from '../../common';
import { BankAccountView } from './bankAccountView';
import { handleErrors } from '../../../utils/handleErrors';

interface Props {
  submenuTab: string;
  onBack: () => void;
  bankSubmenuTab: string;
}

const BankAccountManager: React.FC<Props> = ({ submenuTab, onBack }) => {
  const [bankAccounts, setBankAccounts] = useState<BankData[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState<BankData | null>(null);
  
  
  const [showCreateForm, setShowCreateForm] = useState(false);
  const[hideBankAccountView, setHideBankAccountView] = useState<boolean>(false)
  const [searchedBankName, setSearchedBankName] = useState('');


  useEffect(() => {
    fetchBankAccounts();
  }, []);

  const fetchBankAccounts = async () => {
    try {
      const fetchedBankAccounts = await getBankAccounts();
      setBankAccounts(fetchedBankAccounts);
    } catch (error) {
      handleErrors(error, setErrorMessage,);
    }
  };


  const handleCreateBankAccount = async (formData: BankData) => {
    try {
      const newBankAccount = await createBankAccount({
        ...formData,
        currency: 'NGN',
        isActive: true,
      });
      setBankAccounts((oldAccounts) => [...oldAccounts, newBankAccount]);
      setShowCreateForm(false);
      setHideBankAccountView(false);
    } catch (error) {
      handleErrors(error, setErrorMessage,);
      toast.error('Unable to create Bank Account. Please try again');
    }
  };

  const handleDeleteBankAccount = async (index: number) => {
    try {
      await deleteBankAccount(index);
      setBankAccounts((oldAccounts) => oldAccounts.filter((account, i) => i !== index));
    } catch (error) {
      handleErrors(error, setErrorMessage,);
      toast.error('Error deleting bank account');
    }
  };


  const handleToggleActive = async (index: number) => {
    try {
      const bankAccount = bankAccounts[index];
      const updatedBankAccount = { ...bankAccount, isActive: !bankAccount.isActive };
      await editBankAccount(index, updatedBankAccount);
      setBankAccounts((oldAccounts) =>
        oldAccounts.map((account, i) => i === index ? updatedBankAccount : account)
      );
    } catch (error) {
      handleErrors(error, setErrorMessage,);
    }
  };

  const handleAddNewAccount = () => {
    setShowCreateForm(true);
    setHideBankAccountView(false)
    setIsLoading(false); 
 
  };
  



  return (
    <div className="flex md:block justify-center md:justify-stretch">
      <div className="bg-[#FFFFFF] w-[350px] mx-[-60px] sm:mx-0 sm:w-full min-h-screen lg:w-full mt-[-1.2em] lg:mt-[-1em] lg:ml-[-1em] lg:min-h-screen">
        <h1 className="text-[16px] lg:text-[20px] font-semibold lg:font-semibold pl-[20px] pt-[24px] sm:pl-[24px] lg:pl-[64px] sm:pt-[32px] lg:pt-[55px]">
          Bank Account
        </h1>
        <p className="text-[12px] ml-[1.4em] font-sm lg:text-[16px] md:ml-[1.9em] lg:font-sm sm:pl-[24px] lg:ml-[3.6em] lg:pt-[7px] xl:ml-[4em] pb-[10px] sm:pb-[24px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>
          Add payment links integrated to your business account.
        </p>
        <hr className="lg:mt-[1em] lg:w-full" />
  
            {showCreateForm ? (
          <CreateBankAccount onCreate={handleCreateBankAccount} showButton={false} />
        ) : (
          <>
            {bankAccounts.length === 0 ? (
              <CreateBankAccount onCreate={handleCreateBankAccount} showButton={true} />
            ) : (
              <div className="grid grid-cols-1  biglglg:grid-cols-2 biglg:flex biglg:justify-start xl::grid-cols-2  xl:flex xl:justify-start xl:gap-0">
                {bankAccounts.map((bankAccount, index) => (
                  <BankAccountView
                    key={bankAccount.id}
                    accountIndex={index}
                    bankAccount={bankAccount}
                    onEdit={() => setFormData(bankAccount)}
                    onDelete={() => handleDeleteBankAccount(index)}
                    onToggleActive={() => handleToggleActive(index)}
                  />
                ))}
              </div>
            )}

            {!showCreateForm && bankAccounts.length > 0 && (
              <div className="lg:w-full flex justify-center items-center lg:h-[48px] lg:flex lg:mt-[69px] lg:justify-start lg:ml-[4em]">
                <div className="w-[310px] md:w-[434px] lg:w-[300px] biglg:w-[400px] xl:w-[434px] mt-[32px] lg:mt-0">
                  <Button
                    type="submit"
                    text="Add Bank Account"
                    isLoading={isLoading}
                    disabled={isLoading}
                    onClick={handleAddNewAccount}
                  >
                    {isLoading ? 'Loading...' : 'Add Bank Account'}
                  </Button>
                </div>
              </div>
            )}
          </>
         )} 
      </div>
    </div>
  );
};
export default BankAccountManager; 